import type { FooterProps } from '@/components/landing-page/components/footer';

export const defaults: Required<FooterProps> = {
  groups: [],
};
